export default __webpack_public_path__ + "static/media/orange_warning.e0d4c8e3.svg";